import type { ReactNode } from 'react';
import Eyebrow from '../atoms/Eyebrow';
import Button from '../atoms/Button';

// PR-UX-04 4-states · error.
// PR-UX-10 H9 (Nielsen heuristic 9) · clear identification + recovery action.
interface ErrorStateProps {
  eyebrow?: string;
  title: ReactNode;
  message?: ReactNode;
  retry?: () => void;
  retryLabel?: string;
  supportEmail?: string;
  className?: string;
}

export default function ErrorState({
  eyebrow = 'Error',
  title,
  message,
  retry,
  retryLabel = 'Retry',
  supportEmail = 'support@fyd.dev',
  className = '',
}: ErrorStateProps) {
  return (
    <div className={`text-center py-12 ${className}`}>
      <Eyebrow tone="vermilion" className="mb-2">{eyebrow}</Eyebrow>
      <h2 className="font-serif text-2xl font-medium mb-2">{title}</h2>
      {message && <p className="text-base text-ink-2 max-w-md mx-auto mb-6">{message}</p>}
      {retry && (
        <Button variant="secondary" onClick={retry}>
          {retryLabel}
        </Button>
      )}
      <p className="text-xs text-ink-3 mt-6">
        Need help?{' '}
        <a href={`mailto:${supportEmail}`} className="text-ink border-b border-current pb-px">
          {supportEmail}
        </a>
      </p>
    </div>
  );
}
